import React from "react";
import styled from "styled-components";

const StyledTitleSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  padding-top: 7px;
  padding-bottom: 7px;

  background-color: #eaeaea;

  .title-section-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 980px;

    padding-left: 15px;
    padding-right: 15px;

    .title-section-text {
      font-family: 'Arial';
      font-weight: bold;
      font-size: 14px;
      line-height: calc(1.42857rem * (14 / 16));
      text-transform: uppercase;
      color: #424242;
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    .title-section-container {
      width: 720px;
    } 
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .title-section-container {
      width: 100%;
    } 
  }
`;

function TitleSection({ title }) {
  return (
    <StyledTitleSection>
      <div className="title-section-container">
        <div className="title-section-text">
          {title && (
            <span>{title}</span>
          )}
        </div>
      </div>
    </StyledTitleSection>
  );
}

export default TitleSection;
